// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-container {
    background-color: #f0f2f5; /* tom cinza-azulado claro */
}

.filter-title {
    color: #1f2d3d; /* quase preto */
}

.date-range label,
.row-limit label,
.order-direction label,
.filter-item label {
    color: #3c4a57;
}

.date-range input[type="datetime-local"],
.row-limit input[type="number"],
.order-direction select {
    border: 1px solid #cfd8e3;
    background-color: #ffffff;
}

.order-direction select:focus {
    border-color: #2563eb;
    box-shadow: 0 0 5px rgba(37, 99, 235, 0.5);
}

.filter-item input[type="checkbox"] {
    accent-color: #2563eb; /* azul elegante */
}

.filter-button {
    background-color: #2563eb; /* azul moderno */
}

.filter-button:hover {
    background-color: #1e40af;
}

.csv-button {
    background-color: #10b981; /* verde elegante */
}

.csv-button:hover {
    background-color: #047857;
}

.csv-button:focus {
    outline: 2px solid #ffffff;
}

.tabela-reforma th {
    background-color: #e2e8f0; /* azul-cinza bem claro */
    color: #1f2d3d;
}

.tabela-reforma td {
    border: 1px solid #e0e0e0;
    color: #333;
}

.paginacao button {
    background-color: #e2e8f0;
    border: 1px solid #cbd5e1;
    color: #1f2d3d;
}

.paginacao button.active {
    background-color: #2563eb;
    color: white;
    border-color: #2563eb;
}

.paginacao button:disabled {
    background-color: #e5e7eb;
    color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/components/reforma/styles.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,4BAA4B;AAC3D;;AAEA;IACI,cAAc,EAAE,gBAAgB;AACpC;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;;;IAGI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB,EAAE,kBAAkB;AAC7C;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;AAChD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,EAAE,mBAAmB;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;IACpD,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".filter-container {\n    background-color: #f0f2f5; /* tom cinza-azulado claro */\n}\n\n.filter-title {\n    color: #1f2d3d; /* quase preto */\n}\n\n.date-range label,\n.row-limit label,\n.order-direction label,\n.filter-item label {\n    color: #3c4a57;\n}\n\n.date-range input[type=\"datetime-local\"],\n.row-limit input[type=\"number\"],\n.order-direction select {\n    border: 1px solid #cfd8e3;\n    background-color: #ffffff;\n}\n\n.order-direction select:focus {\n    border-color: #2563eb;\n    box-shadow: 0 0 5px rgba(37, 99, 235, 0.5);\n}\n\n.filter-item input[type=\"checkbox\"] {\n    accent-color: #2563eb; /* azul elegante */\n}\n\n.filter-button {\n    background-color: #2563eb; /* azul moderno */\n}\n\n.filter-button:hover {\n    background-color: #1e40af;\n}\n\n.csv-button {\n    background-color: #10b981; /* verde elegante */\n}\n\n.csv-button:hover {\n    background-color: #047857;\n}\n\n.csv-button:focus {\n    outline: 2px solid #ffffff;\n}\n\n.tabela-reforma th {\n    background-color: #e2e8f0; /* azul-cinza bem claro */\n    color: #1f2d3d;\n}\n\n.tabela-reforma td {\n    border: 1px solid #e0e0e0;\n    color: #333;\n}\n\n.paginacao button {\n    background-color: #e2e8f0;\n    border: 1px solid #cbd5e1;\n    color: #1f2d3d;\n}\n\n.paginacao button.active {\n    background-color: #2563eb;\n    color: white;\n    border-color: #2563eb;\n}\n\n.paginacao button:disabled {\n    background-color: #e5e7eb;\n    color: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
